enum EFreeResponsesTheme {
    Blue = "blue",
    Transparent = "transparent"
}

enum EFreeResponsesFormField {
    QuestionList = "questionList"
}

type TFreeResponsesFormQuestion = {
    answer: string
    id: string
    question: string
    idx: number
}

type TFreeResponsesQuestion = {
    initialState: { id: string; question: string; answer: string; placeholder: string | undefined; isRequired: boolean }
    submittedState: { id: string; question: string; answer: string } | null
}

type TFreeResponsesSubmittedQuestion = { id: string; answer: string; question: string }

type TFreeResponsesFormData = {
    [EFreeResponsesFormField.QuestionList]: TFreeResponsesFormQuestion[]
}

type TFreeResponsesEntityRef = { isCompleted: boolean }

type TFreeResponsesConfig = {
    theme: EFreeResponsesTheme
    title: string | undefined
    questions: TFreeResponsesQuestion[]
    isRequired: boolean
    isError: boolean
    withManualSubmit?: boolean
    manualSubmitButtonText?: string
    wrapperClassName?: string
    onAllQuestionsComplete?(list: TFreeResponsesSubmittedQuestion[]): Promise<void>
}

export { EFreeResponsesTheme, EFreeResponsesFormField }
export type {
    TFreeResponsesQuestion,
    TFreeResponsesSubmittedQuestion,
    TFreeResponsesFormQuestion,
    TFreeResponsesFormData,
    TFreeResponsesEntityRef,
    TFreeResponsesConfig
}
